import { type PackagingUoms } from "../types/packaging"

import { CompanyDefaultUnitOfMeasurement, FieldGroupEnum, ProductStockType } from "@/graphql/codegen/graphql"

export const ProductFileTypeToLabel: Partial<Record<FieldGroupEnum, string>> = {
  [FieldGroupEnum.ProductCoa]: "COA",
  [FieldGroupEnum.ProductCoo]: "COO",
  [FieldGroupEnum.ProductLabwork]: "Labwork",
  [FieldGroupEnum.Miscellaneous]: "Miscellaneous",
  [FieldGroupEnum.ProductSds]: "SDS",
  [FieldGroupEnum.ProductTds]: "TDS",
}

export const INCH_UOM_ID = "USSTD_DISTANCE_INCH"

export const UOM_PAIRS: { value: PackagingUoms; label: string; id: string }[] = [
  {
    value: {
      us: CompanyDefaultUnitOfMeasurement.UsstdWeightPound,
      metric: CompanyDefaultUnitOfMeasurement.MetricWeightKilogram,
    },
    label: "Pound (lb) / Kilogram (kg)",
  },
  {
    value: {
      us: CompanyDefaultUnitOfMeasurement.UsstdWeightShortTon,
      metric: CompanyDefaultUnitOfMeasurement.MetricWeightTon,
    },
    label: "Short Ton (st) / Metric Ton (mt)",
  },
  {
    value: {
      us: "USSTD_VOLUME_GALLON",
      metric: "METRIC_VOLUME_LITER",
    },
    label: "Gallon (gal) / Liter (l)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_CASE",
      metric: "METRIC_WEIGHT_CASE",
    },
    label: "Cases (cs)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_EACH",
      metric: "METRIC_WEIGHT_EACH",
    },
    label: "Each (ea)",
  },
  {
    value: {
      us: "USSTD_WEIGHT_ROLL",
      metric: "METRIC_WEIGHT_ROLL",
    },
    label: "Rolls (rol)",
  },
].map(({ value, label }) => ({ value, label, id: [value.us, value.metric].join("-") }))

export const STOCK_TYPES = [
  {
    label: "Stock",
    value: ProductStockType.StockItem,
  },
  {
    label: "Non Stock",
    value: ProductStockType.NonStockItem,
  },
  {
    label: "Made to Order",
    value: ProductStockType.MadeToOrder,
  },
]

export const TABLE_HEADERS = [
  { label: "Assigned Warehouses" },
  { label: "Stock" },
  { label: "Combined Pricing" },
  { label: "Allocation" },
  { label: "" },
]
